import axios from "axios";
import { app } from "../config";
import getHeaders from "./authHeaders";

export const getSerial = async (shortCode,check=false) => {
  try {
    // let resp = await axios.post(`https://websitestagging.know.us/api/v1/admin/inventory/mapping?shortCode=oxJI1-ckyj9`,{}, { headers: getHeaders() });
    
    let resp = await axios.post(`${app.URL}/api/v1/admin/inventory/mapping?shortCode=${shortCode}`, {}, { headers: getHeaders() });
    console.log('resp', resp?.data?.result?.data?.serialNo);
    const serial = check ? resp?.data?.result?.data?.shortCode : resp?.data?.result?.data?.serialNo;
// console.log("serial",serial)
    
    // setisEncrypt(false);
    return serial
  } catch (error) {
    console.log('error in getSerial', error);
    // setisEncrypt(false);
  }
};
